var map = {
	"./anaelBerlisnky.png": 1760,
	"./beUnique.png": 9456,
	"./edenShviro.png": 316,
	"./evlinTurjeman.png": 4180,
	"./ilanitKopel.png": 7216,
	"./inbarDrori.png": 88,
	"./liaBar.png": 980,
	"./maliAtias.png": 5092,
	"./miraPeretz.png": 4711,
	"./moranAzarzar.png": 8516,
	"./nataliYomTov.png": 4956,
	"./oksanaFreidin.png": 6084,
	"./revitalEdri.png": 9292,
	"./roniBiton.png": 1416,
	"./roniLevi.png": 6916,
	"./sigalitVanunu.png": 4660,
	"./sivanGafni.png": 7232,
	"./svetlanaCavalli.png": 3192,
	"./taliaBenAtar.png": 7012,
	"./tanya.png": 9504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7112;